import type { OverviewItem } from "@/components/types";
import { renderTextWithBold } from "../utils/renderTextWithBold";
import { Badge } from "@/components/ui/badge";

interface OverviewItemRendererProps {
  item: OverviewItem;
}

const OverviewItemRenderer = ({ item }: OverviewItemRendererProps) => {
  switch (item.type) {
    case "title":
      return (
        <h1 className="text-2xl max-md:text-xl max-sm:text-lg font-semibold text-right mb-6">{renderTextWithBold(item.text)}</h1>
      );

    case "subtitle":
      return (
        <h2 className="text-xl max-md:text-lg max-sm:text-base font-semibold text-right mx-4">{renderTextWithBold(item.text)}</h2>
      );

    case "paragraph":
      return <p className="text-base max-sm:text-sm text-right mb-4 leading-relaxed mx-4">{renderTextWithBold(item.text)}</p>;

    case "unordered_list":
      return (
        <ul className="text-base max-sm:text-sm text-right mb-4 space-y-2 list-disc list-outside mr-8">
          {item.items && Array.isArray(item.items) ? (
            item.items.map((listItem, idx) => <li key={idx}>{renderTextWithBold(listItem.text)}</li>)
          ) : (
            <li className="text-slate-400 text-sm">אין פריטים ברשימה</li>
          )}
        </ul>
      );

    case "ordered_list":
      return (
        <div className="mb-4">
          <div className="flex items-center justify-start gap-2 mb-3">
            <Badge variant="outline">
              <h3 className="text-lg text-indigo-600 max-md:text-base font-semibold text-right">{item.content}</h3>
            </Badge>
          </div>
          <ol className="text-base max-sm:text-sm text-slate-600 text-right space-y-2 mr-6">
            {item.items && Array.isArray(item.items) ? (
              item.items.map((listItem, idx) => (
                <li key={idx} className="flex items-baseline gap-2">
                  <span className="text-indigo-500">{idx + 1}.</span>
                  <span>{renderTextWithBold(listItem.text)}</span>
                </li>
              ))
            ) : (
              <li className="text-slate-400 text-sm">אין פריטים ברשימה</li>
            )}
          </ol>
        </div>
      );

    default:
      return null;
  }
};

export default OverviewItemRenderer;
